// For regional credit we need to mock the get questions failing
// then it will hit the regional credit service
const regionalCreditCheck = require('../../mock/creditRcc.json');

export default {
  getQuestions: () =>
    new Promise(reject => {
      setTimeout(() => {
        reject();
      }, 1000);
    }),
  getRegionalCreditScore: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({ data: regionalCreditCheck });
      }, 1000);
    }),
};
